// dedupeOptimisticEcho.js — FASE-12 E7 (achado live). Colapsa DUAS bolhas ADJACENTES
// da mesma mensagem do usuário quando ao menos uma é OTIMISTA.
//
// O bug (reproduzido no .app + confirmado por estado): a 1ª mensagem de uma sessão
// nova do Chat renderizava DUAS bolhas idênticas; após reload a sessão ficava vazia
// ("Nenhuma mensagem ainda") — logo AMBAS eram otimistas/efêmeras (o auto-first-message
// dispara handleSend mais de uma vez no mount/remount → dois `optimistic-*` com o mesmo
// texto). Este filtro, na fonte única das mensagens (SessionWorkspace), colapsa o par
// adjacente. Preferência: mantém o de id REAL (persistido) quando existe — rewind/fork
// dependem do id do servidor; senão mantém a primeira otimista. NUNCA colapsa duas
// mensagens persistidas distintas (repetição legítima do usuário). PURO.

const isOptimistic = (m) => m && typeof m.id === 'string' && m.id.startsWith('optimistic-');
const sameBubble = (a, b) => a && b && a.role === b.role && a.content === b.content;

/**
 * @param {Array<{id?: string, role?: string, content?: string}>} messages
 * @returns {Array} a lista com pares adjacentes otimista-duplicados colapsados
 */
export function dedupeOptimisticEcho(messages) {
  if (!Array.isArray(messages)) return [];
  const out = [];
  for (const m of messages) {
    const prev = out[out.length - 1];
    // Só colapsa quando o par é IDÊNTICO (role+content) E ao menos um é otimista —
    // dois persistidos iguais (o usuário repetiu a msg de propósito) NÃO são tocados.
    if (sameBubble(prev, m) && (isOptimistic(prev) || isOptimistic(m))) {
      if (isOptimistic(prev) && !isOptimistic(m)) out[out.length - 1] = m; // troca otimista→persistida
      continue; // dropa o duplicado
    }
    out.push(m);
  }
  return out;
}
